import axios from "axios";
import { Config } from "../constants/Config";
import { LogoutUser } from "../utils/CommonFunction";

const getBaseUrl = () => {
  const isHttp = window.location.protocol === "http:";
  return isHttp
    ? Config.BASE_URL.replace(/^https:\/\//, "http://")
    : Config.BASE_URL;
};

export const apiClient = axios.create({
  baseURL: getBaseUrl(),
  timeout: Config.TIMEOUT,
});

// Request interceptor
apiClient.interceptors.request.use((config) => {
  // If a token was already explicitly provided in the request config, keep it.
  if (!config.headers.Authorization) {
    // @ts-ignore
    const token = global.token || "";
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
  }
  return config;
});

// Response interceptor
apiClient.interceptors.response.use(
  (response) => {
    // Return data directly to match old handleResponse behavior where response.json() was returned
    return response;
  },
  (error) => {
    if (error.response && error.response.status === 403) {
      LogoutUser();
      return Promise.reject("403 Forbidden: Logging out.");
    }
    return Promise.reject(error);
  }
);
